import { AssetGenerationBundle, AssetGenerationProgress } from "../model";
export var QualityLevel;
(function (QualityLevel) {
    QualityLevel[QualityLevel["HIGH"] = 0] = "HIGH";
    QualityLevel[QualityLevel["FAST"] = 1] = "FAST";
})(QualityLevel || (QualityLevel = {}));
;
